import { FSharpException, toString, Record } from "../fable-library.3.7.20/Types.js";
import { record_type, array_type, uint8_type, class_type, list_type, string_type, int32_type } from "../fable-library.3.7.20/Reflection.js";
import { fromContinuations } from "../fable-library.3.7.20/Async.js";
import { add, empty, ofArray, iterate } from "../fable-library.3.7.20/Map.js";
import { printf, toFail, split, join } from "../fable-library.3.7.20/String.js";
import { mapIndexed, equalsWith, choose } from "../fable-library.3.7.20/Array.js";
import { singleton, ofArray as ofArray_1 } from "../fable-library.3.7.20/List.js";
import { get_UTF8 } from "../fable-library.3.7.20/Encoding.js";
import { toArray } from "../fable-library.3.7.20/Seq.js";
import { rangeDouble } from "../fable-library.3.7.20/Range.js";
import { some } from "../fable-library.3.7.20/Option.js";
import { equals } from "../fable-library.3.7.20/Util.js";
import { Uri } from "../fable-library.3.7.20/Uri.js";

export class HttpResponse extends Record {
    constructor(Status, Headers, Body) {
        super();
        this.Status = (Status | 0);
        this.Headers = Headers;
        this.Body = Body;
    }
}

export function HttpResponse$reflection() {
    return record_type("Fenix.Dry.Http.HttpResponse", [], HttpResponse, () => [["Status", int32_type], ["Headers", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, list_type(string_type)])], ["Body", array_type(uint8_type)]]);
}

export class HttpRequest extends Record {
    constructor(Url, HttpMethod, Headers, Body) {
        super();
        this.Url = Url;
        this.HttpMethod = HttpMethod;
        this.Headers = Headers;
        this.Body = Body;
    }
}

export function HttpRequest$reflection() {
    return record_type("Fenix.Dry.Http.HttpRequest", [], HttpRequest, () => [["Url", class_type("System.Uri")], ["HttpMethod", string_type], ["Headers", class_type("Microsoft.FSharp.Collections.FSharpMap`2", [string_type, list_type(string_type)])], ["Body", array_type(uint8_type)]]);
}

export function ClientModule_sendAsync(timeoutMs, req) {
    return fromContinuations((tupledArg) => {
        const xhr = new XMLHttpRequest();
        xhr.timeout = (timeoutMs | 0);
        xhr.withCredentials = true;
        xhr.open(req.HttpMethod, toString(req.Url));
        iterate((key, value) => {
            xhr.setRequestHeader(key, join(",", value));
        }, req.Headers);
        xhr.onreadystatechange = (() => {
            let h, matchValue_1, buffer, k, blob, k_1;
            if (xhr.readyState === 4) {
                tupledArg[0](new HttpResponse(xhr.status, (h = xhr.getAllResponseHeaders(), ofArray(choose((x) => {
                    if (x === "") {
                        return void 0;
                    }
                    else {
                        const matchValue = split(x, [": "], null, 0);
                        if ((!equalsWith((x_1, y) => (x_1 === y), matchValue, null)) && (matchValue.length === 2)) {
                            const value_1 = matchValue[1];
                            return [matchValue[0], ofArray_1(split(value_1, [","], null, 0))];
                        }
                        else {
                            return toFail(printf("Unexpected header format \u0027%s\u0027"))(x);
                        }
                    }
                }, split((h === null) ? "" : h, ["\r\n"], null, 0)))), (matchValue_1 = xhr.responseType, (matchValue_1 === "") ? get_UTF8().getBytes(xhr.responseText) : ((matchValue_1 === "text") ? get_UTF8().getBytes(xhr.responseText) : ((matchValue_1 === "arraybuffer") ? ((buffer = xhr.response, (k = (new Uint8Array(buffer)), mapIndexed((i, x_2) => (k[i]), toArray(rangeDouble(0, 1, k.length - 1)), Uint8Array)))) : ((matchValue_1 === "blob") ? ((blob = xhr.response, (k_1 = (new Uint8Array(() => blob.arrayBuffer())), mapIndexed((i_1, x_3) => (k_1[i_1]), toArray(rangeDouble(0, 1, k_1.length - 1)), Uint8Array)))) : toFail(printf("Unsupported responseType: %s"))(matchValue_1)))))));
            }
        });
        const matchValue_2 = req.Body;
        if ((!equalsWith((x_4, y_1) => (x_4 === y_1), matchValue_2, null)) && (matchValue_2.length === 0)) {
            xhr.send();
        }
        else {
            xhr.send(some(matchValue_2));
        }
    });
}

export class HttpResponseModule_NonSuccessfullHttpStatuscode extends FSharpException {
    constructor(Data0) {
        super();
        this.Data0 = Data0;
    }
}

export function HttpResponseModule_NonSuccessfullHttpStatuscode$reflection() {
    return class_type("Fenix.Dry.Http.HttpResponseModule.NonSuccessfullHttpStatuscode", void 0, HttpResponseModule_NonSuccessfullHttpStatuscode, class_type("System.Exception"));
}

function HttpResponseModule_NonSuccessfullHttpStatuscode__Equals_229D3F39(this$, obj) {
    if (!equals(this$, null)) {
        if (!equals(obj, null)) {
            if (obj instanceof HttpResponseModule_NonSuccessfullHttpStatuscode) {
                return equals(this$.Data0, obj.Data0);
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    else if (!equals(obj, null)) {
        return false;
    }
    else {
        return true;
    }
}

export function HttpResponseModule_createResponse(status, headers, body) {
    return new HttpResponse(status, headers, body);
}

export function HttpResponseModule_str(status, encoding, body) {
    return HttpResponseModule_createResponse(status, empty(), encoding.getBytes(body));
}

export function HttpResponseModule_strUtf8(status, body) {
    return HttpResponseModule_str(status, get_UTF8(), body);
}

export function HttpResponseModule_isSuccess(resp) {
    if (resp.Status >= 200) {
        return resp.Status <= 299;
    }
    else {
        return false;
    }
}

export function HttpResponseModule_asStr(encoding, response) {
    return encoding.getString(response.Body);
}

export function HttpResponseModule_asStrUtf8(response) {
    return HttpResponseModule_asStr(get_UTF8(), response);
}

export function HttpResponseModule_ensureSuccessStatusCode(resp) {
    if (HttpResponseModule_isSuccess(resp)) {
    }
    else {
        throw (new HttpResponseModule_NonSuccessfullHttpStatuscode({
            Body: HttpResponseModule_asStrUtf8(resp),
            StatusCode: resp.Status,
        }));
    }
}

function HttpRequestModule_createRequest(url, httpMethod, headers, body) {
    return new HttpRequest(Uri.create(url), httpMethod, headers, body);
}

export function HttpRequestModule_create(httpMethod, url, contentType, body) {
    return HttpRequestModule_createRequest(url, httpMethod, (contentType == null) ? empty() : add("Content-Type", singleton(contentType), empty()), body);
}

export function HttpRequestModule_Header_set(key, value, req) {
    return new HttpRequest(req.Url, req.HttpMethod, add(key, singleton(value), req.Headers), req.Body);
}

export function HttpRequestModule_Header_contentType(contentTypeValue) {
    return (req) => HttpRequestModule_Header_set("Content-Type", contentTypeValue, req);
}

export function HttpResponse__AsUtf8String(x) {
    return HttpResponseModule_asStrUtf8(x);
}

export function HttpResponse__EnsureSuccessStatusCode(x) {
    HttpResponseModule_ensureSuccessStatusCode(x);
    return x;
}

export function HttpRequest_Create_Z19399594(httpMethod, url, contentType, body) {
    return HttpRequestModule_create(httpMethod, url, contentType, body);
}

export function HttpRequest_Create_Z2EAA567E(httpMethod, url, body) {
    return HttpRequestModule_create(httpMethod, url, void 0, body);
}

export function HttpRequest_Create_Z384F8060(httpMethod, url) {
    return HttpRequestModule_create(httpMethod, url, void 0, new Uint8Array([]));
}

export function HttpRequest_Create_7D749BC5(httpMethod, url, body, encoding) {
    return HttpRequestModule_create(httpMethod, url, void 0, encoding.getBytes(body));
}

export function HttpRequest_Create_Z50383002(httpMethod, url, contentType, body, encoding) {
    return HttpRequestModule_create(httpMethod, url, contentType, encoding.getBytes(body));
}

export function HttpRequest_Create_Z46998140(httpMethod, url, contentType, body) {
    return HttpRequest_Create_Z50383002(httpMethod, url, contentType, body, get_UTF8());
}

export function HttpRequest_Create_30230F9B(httpMethod, url, body) {
    return HttpRequest_Create_7D749BC5(httpMethod, url, body, get_UTF8());
}

export function HttpRequest_Post_72416CE2(url, body, contentType) {
    return HttpRequest_Create_Z19399594("POST", url, contentType, body);
}

export function HttpRequest_Post_26C6D9B9(url, body) {
    return HttpRequest_Create_Z2EAA567E("POST", url, body);
}

export function HttpRequest_Post_30230F9B(url, body, contentType) {
    return HttpRequest_Create_Z46998140("POST", url, contentType, body);
}

export function HttpRequest_Post_Z384F8060(url, body) {
    return HttpRequest_Create_Z46998140("POST", url, "application/octet-stream", body);
}

export function HttpRequest_Get_Z721C83C5(url) {
    return HttpRequestModule_create("GET", url, void 0, new Uint8Array([]));
}

export function HttpRequest__SetHeader_Z384F8060(x, key, value) {
    return HttpRequestModule_Header_set(key, value, x);
}

export class Client {
    constructor() {
    }
}

export function Client$reflection() {
    return class_type("Fenix.Dry.Http.Client", void 0, Client);
}

export function Client_get_DefaultTimeoutMs() {
    return 60000;
}

export function Client_SendAsync_Z5E70852B(request, timeout) {
    return ClientModule_sendAsync(timeout, request);
}

export function Client_SendAsync_Z266B1097(request) {
    return ClientModule_sendAsync(Client_get_DefaultTimeoutMs(), request);
}

export function HttpRequest__SendAsync_Z524259A4(x, timeout) {
    return Client_SendAsync_Z5E70852B(x, timeout);
}

export function HttpRequest__SendAsync(x) {
    return Client_SendAsync_Z266B1097(x);
}

